import { Home, Building2, Factory, Landmark, Scissors, Hammer, Layers, Waves, ShieldAlert } from "lucide-react";

const A = "https://customer-assets-rejwkqb3.emergentagent.net/job_demolition-requests/artifacts";

export const COMPANY = {
  name: "Vision Démolition",
  phone: "514-775-8347",
  phoneHref: "tel:+15147758347",
  email: "info@visiondemolition.ca",
  region: "Grand Montréal, Laval, Rive-Sud, Rive-Nord & Québec",
};

export const PROJECT_TYPES = [
  "Résidentiel",
  "Commercial",
  "Industriel",
  "Institutionnel",
];

export const WORK_TYPES = [
  "Démolition complète",
  "Démolition sélective",
  "Démolition intérieure",
  "Démolition de murs",
  "Démolition de planchers",
  "Démolition de plafonds",
  "Démolition de béton",
  "Démolition de fondations",
  "Démolition de piscine",
  "Démolition de cheminée",
  "Démolition de structure",
  "Démolition industrielle",
  "Démantèlement",
  "Décontamination",
  "Autre",
];

export const REGIONS = [
  "Montréal", "Laval", "Longueuil", "Rive-Sud", "Rive-Nord",
  "Québec", "Montérégie", "Laurentides", "Lanaudière", "Autre",
];

export const CLIENT_TYPES = ["Particulier", "Entrepreneur général", "Gestionnaire immobilier", "Promoteur", "Institution / Municipalité", "Industrie"];
export const CONTACT_METHODS = ["Téléphone", "Courriel", "Texto"];

export const TIMELINES = [
  "Dès que possible",
  "Dans les 30 prochains jours",
  "Dans les 1 à 3 prochains mois",
  "Dans plus de 3 mois",
  "Date précise",
];

export const SERVICES = [
  { icon: Home, title: "Démolition résidentielle", slug: "residentielle", desc: "Maisons, garages, annexes et rénovations majeures exécutées proprement, dans le respect des voisinages." },
  { icon: Building2, title: "Démolition commerciale", slug: "commerciale", desc: "Commerces, bureaux et espaces locatifs libérés rapidement pour accélérer votre échéancier de construction." },
  { icon: Factory, title: "Démolition industrielle", slug: "industrielle", desc: "Usines, entrepôts et infrastructures lourdes démantelés avec des équipements de grande capacité." },
  { icon: Scissors, title: "Démolition sélective", slug: "selective", desc: "Retrait chirurgical d'éléments ciblés tout en préservant les structures à conserver." },
  { icon: Hammer, title: "Démolition intérieure", slug: "interieure", desc: "Mise à nu complète d'espaces intérieurs pour réaménagement, sans compromettre la structure." },
  { icon: Layers, title: "Béton & structures", slug: "beton", desc: "Découpe, concassage et retrait de dalles, fondations, murs porteurs et structures d'acier." },
  { icon: Landmark, title: "Démolition de bâtiments", slug: "batiments", desc: "Démolition complète de bâtiments de toutes tailles, incluant gestion des débris et remise en état." },
  { icon: Waves, title: "Piscines & structures particulières", slug: "piscines", desc: "Retrait de piscines, cheminées et structures atypiques avec remblai certifié." },
  { icon: ShieldAlert, title: "Décontamination", slug: "decontamination", desc: "Gestion des matières dangereuses et décontamination conforme aux normes en vigueur." },
];

export const PROJECTS = [
  { title: "Tour de bureaux — Centre-ville", type: "Démolition commerciale", location: "Montréal", desc: "Démantèlement complet d'un immeuble de 6 étages en milieu urbain dense.", work: "Démolition structurale, gestion des débris, recyclage 85%", img: `${A}/vhpestvp_d68f9a12-620f-4ede-ab2a-ffcb44147fa7.png` },
  { title: "Complexe industriel", type: "Démolition industrielle", location: "Rive-Sud", desc: "Démolition d'un ancien complexe manufacturier de 40 000 pi².", work: "Démantèlement d'acier, décontamination, concassage béton", img: "https://images.pexels.com/photos/13136844/pexels-photo-13136844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "Réaménagement intérieur", type: "Démolition intérieure", location: "Laval", desc: "Mise à nu complète d'un plateau commercial pour réaménagement.", work: "Démolition sélective, retrait cloisons et planchers", img: `${A}/gdo7q5xo_Interior-demolition-services-1.jpg` },
  { title: "Structure de stationnement", type: "Béton & structures", location: "Longueuil", desc: "Découpe et retrait d'une structure de béton armé multi-niveaux.", work: "Découpe béton, retrait fondations, remblai certifié", img: "https://images.pexels.com/photos/17951553/pexels-photo-17951553.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "Bâtiment institutionnel", type: "Démolition institutionnelle", location: "Québec", desc: "Réfection intérieure complète d'un ancien bâtiment public.", work: "Démolition intérieure, gestion environnementale", img: `${A}/h2sn2lza_Downtown-Fort-Myers-Interior-Demolition.jpg` },
  { title: "Résidence & piscine", type: "Démolition résidentielle", location: "Rive-Nord", desc: "Démolition d'une résidence unifamiliale et retrait de piscine.", work: "Démolition maison, retrait piscine, remise en état terrain", img: "https://images.pexels.com/photos/34891691/pexels-photo-34891691.jpeg" },
];

export const TESTIMONIALS = [
  { name: "Marc Tremblay", role: "Entrepreneur général", text: "Réponse rapide, échéancier respecté et chantier impeccable. Vision Démolition gère les gros projets sans stress.", img: "https://images.pexels.com/photos/34670926/pexels-photo-34670926.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Sophie Gagnon", role: "Gestionnaire immobilier", text: "Une organisation exemplaire. La soumission était claire, détaillée et sans surprise. Je recommande sans hésiter.", img: "https://images.pexels.com/photos/37556455/pexels-photo-37556455.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "David Roy", role: "Promoteur immobilier", text: "Capacité d'exécution impressionnante sur un projet industriel complexe. Sécurité et propreté au rendez-vous.", img: "https://images.pexels.com/photos/8486904/pexels-photo-8486904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const FAQ = [
  { q: "Combien de temps pour recevoir une soumission?", a: "Après réception de votre demande et des documents, notre équipe analyse le projet et vous revient rapidement, généralement en moins de 48 heures ouvrables." },
  { q: "Quels documents dois-je fournir?", a: "Des photos, plans (PDF), plans architecturaux ou structuraux, devis et tout document d'appel d'offres accélèrent grandement l'analyse et la précision du prix." },
  { q: "Gérez-vous les petits et les grands projets?", a: "Oui. De la démolition intérieure résidentielle aux complexes industriels, notre réseau d'exécution nous permet de gérer tous les calibres de projets." },
  { q: "Offrez-vous la gestion des débris et le recyclage?", a: "Absolument. Nous assurons le tri, le recyclage et la disposition conforme des débris, avec une priorité sur la valorisation des matériaux." },
  { q: "Êtes-vous assurés et licenciés?", a: "Oui, nous travaillons avec des partenaires assurés et détenant les licences applicables, dans le respect des normes de sécurité et environnementales." },
];

export const LOGO = `${A}/mtzmeicz_746002966_1657152279747297_2924604036053219882_n-removebg-preview.png`;
export const IMG_EXCAVATOR = `${A}/vhpestvp_d68f9a12-620f-4ede-ab2a-ffcb44147fa7.png`;
export const IMG_WORKERS = `${A}/cl6xk4o6_980b4f29-c34a-4d2e-9d39-b85686d52371.png`;
export const IMG_INTERIOR1 = `${A}/gdo7q5xo_Interior-demolition-services-1.jpg`;
export const IMG_INTERIOR2 = `${A}/h2sn2lza_Downtown-Fort-Myers-Interior-Demolition.jpg`;

export const HERO_IMG = IMG_EXCAVATOR;
export const ABOUT_IMG = IMG_WORKERS;
export const SERVICES_IMG = IMG_WORKERS;
export const BRAND_BANNER = `${A}/7zamjoed_webp_fhd.jpg`;
export const GROUPE_DIPLOMATE_LOGO = `${A}/nto0v08j_242510687_2023107011190286_7911925315008436471_n.jpg`;

export const STATUS_COLORS = {
  "Nouvelle demande": "bg-blue-500/15 text-blue-400 border-blue-500/30",
  "À analyser": "bg-sky-500/15 text-sky-400 border-sky-500/30",
  "Informations manquantes": "bg-amber-500/15 text-amber-400 border-amber-500/30",
  "Analyse en cours": "bg-indigo-500/15 text-indigo-400 border-indigo-500/30",
  "Soumission en préparation": "bg-violet-500/15 text-violet-400 border-violet-500/30",
  "Prix demandé aux partenaires": "bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30",
  "Soumission envoyée": "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
  "En attente de décision": "bg-orange-500/15 text-orange-400 border-orange-500/30",
  "Contrat obtenu": "bg-green-500/15 text-green-400 border-green-500/30",
  "Contrat perdu": "bg-red-500/15 text-red-400 border-red-500/30",
  "Projet en cours": "bg-teal-500/15 text-teal-400 border-teal-500/30",
  "Projet terminé": "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
};
